import { Container } from "@mui/material";
import { Deposit } from "modules/bridge/api/useBridges";
import { BridgeTransaction } from "modules/bridge/components/BridgeTransaction";

interface Props {
  list?: Deposit[];
}

export const DepositsToClaim = ({ list = [] }: Props) => {
  return (
    <Container
      maxWidth="sm"
      style={{
        maxWidth: "640px",
        padding: 0,
      }}
    >
      {list
        ?.filter((deposit) => !deposit.claim_tx_hash)
        .map((deposit) => {
          return (
            <BridgeTransaction
              deposit={deposit}
              key={deposit.tx_hash}
              canClime={false}
              returnTime={""}
            />
          );
        })}
    </Container>
  );
};
